<template>
  <div style="background: #F0F2F5 !important;
        padding: 16px 16px 0px 16px !important;" class="todoindex" :style="conheight">
        <!-- <span class="todotitle">待办事项</span> -->
    <div class="todomenu">
        <el-tabs v-model="activeName">
            <el-tab-pane label="我的假期" name="todo">
                <iframe :src="src+'/fvue/statement/querySql/queryView/ygjqcx/cxgr/true'" class="iframe" style="width:100%;" :style="conheight">
                </iframe>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>


<script>
  export default {
    name: "haiyaVacation",
     components: {
    },
    data() {
      return {
        activeName: 'todo',
         isChildUpdate1:true,
         isChildUpdate2:false,
         conheight: { height: window.innerHeight  + "px"},
         src:window.location.origin
      };
    },
    methods: {
    },
    mounted(){
      window.jQuery(".el-container").find(".el-main").css({"height":window.innerHeight+"px","overflow":"hidden"});
    }
  };
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .iframe .el-main{
  padding: 0px !important;
}

/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 8px;
}


/deep/ .el-main{
  padding: 0px !important;
}
    /deep/ .todotitle{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #292B44;
    }


  /deep/ iframe{
    border: 0px !important;
  }
</style>
